export const POC_CREATE = 'POC_CREATE';
export const POC_UPDATE = 'POC_UPDATE';
export const POC_UPDATE_BY_KEY = 'POC_UPDATE_BY_KEY';
export const POC_GET_LIST = 'POC_GET_LIST';
export const POC_VALIDATE_ITEM = 'POC_VALIDATE_ITEM';
export const POC_GET_HISTORIES = 'POC_GET_HISTORIES';
export const POC_GET_BLOCKCHAIN_LIST = 'POC_GET_BLOCKCHAIN';